import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LayoutDashboard, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

const dashRoute = (role) =>
  role === "admin" ? "/admin" : role === "institute" ? "/institute" : "/dashboard";

export function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/courses", label: "Explore Courses" },
    { to: "/institutes", label: "Institutes" },
    { to: "/#how", label: "How it works" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <Logo className="h-11 sm:h-12" />
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.split(" ")[0].toLowerCase()}`}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <ThemeToggle />
          {user && user !== false ? (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-dashboard-btn"
                onClick={() => nav(dashRoute(user.role))}>
                <LayoutDashboard className="mr-2 h-4 w-4" /> Dashboard
              </Button>
              <Button variant="outline" size="sm" data-testid="nav-logout-btn"
                onClick={() => { logout(); nav("/"); }}>
                <LogOut className="mr-2 h-4 w-4" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-login-btn" onClick={() => nav("/login")}>Sign in</Button>
              <Button size="sm" data-testid="nav-register-btn" onClick={() => nav("/register")}>Get started</Button>
            </>
          )}
        </div>

        <button data-testid="nav-mobile-toggle" className="md:hidden" onClick={() => setOpen((o) => !o)}>
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-background px-4 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                className="text-sm font-medium text-muted-foreground">{l.label}</Link>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <ThemeToggle />
              {user && user !== false ? (
                <>
                  <Button size="sm" onClick={() => { setOpen(false); nav(dashRoute(user.role)); }}>Dashboard</Button>
                  <Button variant="outline" size="sm" onClick={() => { logout(); nav("/"); setOpen(false); }}>Logout</Button>
                </>
              ) : (
                <>
                  <Button variant="ghost" size="sm" onClick={() => { setOpen(false); nav("/login"); }}>Sign in</Button>
                  <Button size="sm" onClick={() => { setOpen(false); nav("/register"); }}>Get started</Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
